import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "../../Components/dashboard.css";
import {
  getAnalytics,
  selectEvents,
  selectTotalEvents,
} from "../../../features/analytics";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";

function Metrics(props) {
  const events = props.events;
  const navigate = useNavigate();
  const [query, setQuery] = useState({ type: "" });
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async (q) => {
    props.getAnalytics(q || query);
  };
  const redirectToDashboard = () => {
    navigate("/admin");
  };
  const handleQueryChange = (param) => (e, i, v) => {
    const value = v.trim().toLowerCase();
    const update = value === "all" ? { [param]: "" } : { [param]: value };
    const q = { ...query, ...update };
    setQuery(q);
    fetchAnalytics(q);
  };
  const contextualDate = (datestring) => {
    const date = new Date(datestring);
    return date.toLocaleString();
  };
  return (
    <div className="dashboard">
      <button onClick={redirectToDashboard} className="backButton">
        <img src={require("../../../Images/leftArrow.png")} alt="<-" />
        Return to Dashboard
      </button>
      <h3 style={{ marginTop: "50px", marginBottom: "24px" }}>Metrics</h3>
      {events && (
        <>
          <Table selectable={false}>
            <TableBody>
              <TableRow>
                <TableRowColumn>
                  <SelectField
                    name="type"
                    hintText={"Select metric type"}
                    value={query.type}
                    onChange={handleQueryChange("type")}
                  >
                    <MenuItem value={""}>All</MenuItem>
                    <MenuItem value={"login"} primaryText="Login" />
                    <MenuItem value={"signup"} primaryText="Signup" />
                  </SelectField>
                </TableRowColumn>
                <TableRowColumn></TableRowColumn>
                <TableRowColumn>
                  <SelectField
                    name="userType"
                    hintText={"Select metric user type"}
                    value={query.userType}
                    onChange={handleQueryChange("userType")}
                  >
                    <MenuItem value={""}>All</MenuItem>
                    <MenuItem value={"admin"} primaryText="Admin" />
                    <MenuItem value={"teacher"} primaryText="Teacher" />
                    <MenuItem value={"student"} primaryText="Student" />
                  </SelectField>
                </TableRowColumn>
                <TableRowColumn></TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
          <div className="results">
            {<b>Total Events: {props.totalEvents}</b>}
            <Table selectable={false}>
              <TableHeader>
                <TableRow>
                  <TableHeaderColumn>Type</TableHeaderColumn>
                  <TableHeaderColumn>Internal userId</TableHeaderColumn>
                  <TableHeaderColumn>User type</TableHeaderColumn>
                  <TableHeaderColumn>timestamp</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody>
                {events.map((e) => (
                  <TableRow key={e._id}>
                    <TableRowColumn>{e.type}</TableRowColumn>
                    <TableRowColumn>
                      {`${e?.data?.user?.firstName ?? ""} ${
                        e?.data?.user?.lastName ?? ""
                      } (${e.user})`}
                    </TableRowColumn>
                    <TableRowColumn>{e.userType}</TableRowColumn>
                    <TableRowColumn>
                      {contextualDate(e.timestamp)}
                    </TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  events: selectEvents(state),
  totalEvents: selectTotalEvents(state),
});
const mapDispatchToProps = {
  getAnalytics,
};
export default connect(mapStateToProps, mapDispatchToProps)(Metrics);
